import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getAuthState } from "slices/auth/login/reducer";
import { useAppSelector } from "slices/hook";

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  const { loggedInuser } = useAppSelector(getAuthState);

  if (!loggedInuser?.id || !loggedInuser.activeTenantId) {
    return <Navigate to={{ pathname: "/admin-login" }} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;
